"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = void 0;
exports.settings = {
  typographySize: {
    xs: "xs",
    sm: "xs",
    md: "sm",
    lg: "md",
    xl: "lg",
    default: "md",
    mobileDefault: "lg"
  },
  iconSize: {
    xs: "xs",
    sm: "sm",
    md: "md",
    lg: "lg",
    xl: "xl",
    default: "md"
  },
  cicleIconTop: {
    sm: "0px",
    md: "0px",
    lg: "0px"
  },
  minHeight: {
    xs: "30px",
    sm: "40px",
    md: "50px",
    lg: "60px",
    xl: "80px",
    default: "50px"
  },
  circMinWidth: {
    xs: "30px",
    sm: "40px",
    md: "50px",
    lg: "60px",
    xl: "80px",
    default: "50px"
  },
  squareMinHeight: {
    xs: "30px",
    sm: "40px",
    md: "50px",
    lg: "60px",
    xl: "80px",
    default: "50px"
  },
  roundedButtonHeights: {
    xs: "30px",
    sm: "40px",
    md: "50px",
    lg: "60px",
    xl: "80px",
    default: "50px"
  },
  squareMinHeightMobile: {
    sm: "30px",
    md: "50px",
    lg: "70px",
    default: "50px"
  },
  squareIconOnlyWidth: {
    xs: "30px",
    sm: "40px",
    md: "50px",
    lg: "60px",
    xl: "80px",
    default: "50px"
  },
  squareIconOnlyHeight: {
    xs: "30px",
    sm: "40px",
    md: "50px",
    lg: "60px",
    xl: "80px",
    default: "50px"
  },
  borderRadiusrounded: {
    xs: "15px",
    sm: "20px",
    md: "25px",
    lg: "30px",
    xl: "40px",
    default: "20px"
  },
  horizontalPaddingRounded: {
    sm: "10px",
    md: "12px",
    default: "14px"
  },
  verticalPaddingRounded: {
    default: "4px"
  }
};